import type { Optional } from '@festina-life/core'
import { useMemo } from 'react'

import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'
import { getParameterDefinitionAtDate } from '../parameterOperations/helpers'

type ParameterDefinitionParams = {
  name: Optional<string>
  atDate: Date
}

export const useParameterDefinitionOperation = ({
  name,
  atDate,
}: ParameterDefinitionParams) => {
  const { applicationParameterDefinitions } =
    useApplicationViewOperationsContext()

  const parameterDefinitions = name
    ? applicationParameterDefinitions?.get(name)
    : undefined

  return useMemo(
    () => getParameterDefinitionAtDate(parameterDefinitions, atDate),
    [atDate, parameterDefinitions],
  )
}
